exports.saveOne = function (state, user) {
  return state.serverUserAdapter.put(user._id, user)
}
